var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { Badge as BaseBadge, Box, Text, useTheme } from "native-base";
import Icon from "../icons/Icon";
import Avatar from "../atoms/Avatar/Avatar";
const Badge = (_a) => {
    var { variant = "success", size = "xs", hasIndicator = true, hasText = true, children, leftIconName, rightIconName, avatar } = _a, rest = __rest(_a, ["variant", "size", "hasIndicator", "hasText", "children", "leftIconName", "rightIconName", "avatar"]);
    const { colors } = useTheme();
    const indicatorVariants = useMemo(() => ({
        success: colors.green[300],
        ghostSuccess: colors.green[300],
        base: colors.green[300],
        ghost: colors.gray[500],
        dark: colors.green[500],
        light: colors.green[500],
        error: colors.rose[200],
        ghostError: colors.rose[500],
        warning: colors.yellow[200],
        ghostWarning: colors.yellow[500],
    }), [colors]);
    const gaps = useMemo(() => ({
        xs: "1",
        sm: "1",
        md: "1",
        lg: "1.5",
        xl: "1.5",
        xxl: "1.5",
    }), []);
    const minWidths = useMemo(() => ({
        xs: "4.5",
        sm: "5.5",
        md: "5.5",
        lg: "6",
        xl: "7",
        xxl: "8",
    }), []);
    const iconVariants = useMemo(() => ({
        success: colors.white,
        ghostSuccess: colors.green[600],
        base: colors.white,
        ghost: colors.gray[600],
        dark: colors.white,
        light: colors.black,
        error: colors.white,
        ghostError: colors.rose[500],
        warning: colors.white,
        ghostWarning: colors.yellow[600],
    }), [colors]);
    const avatarPaddings = useMemo(() => ({
        xs: {
            p: 0,
        },
        sm: {
            p: 0.5,
            pr: 1.5,
        },
        md: {
            p: 0.75,
            pr: 2,
        },
        lg: {
            p: 1,
            pr: 2,
        },
        xl: {
            p: 1.5,
            pr: 2,
        },
        xxl: {
            p: 1.5,
            pr: 2,
        },
    }), []);
    const renderLeftIcon = useCallback(() => {
        if (avatar) {
            if (size === "xs") {
                return;
            }
            return _jsx(Avatar, { size: "2xs", source: avatar });
        }
        if (hasIndicator) {
            return (_jsx(Box, Object.assign({ mr: gaps[size] }, { children: _jsx(Icon, { name: "circleSolid", fill: indicatorVariants[variant], size: 6 }) })));
        }
        if (leftIconName) {
            return (_jsx(Box, Object.assign({ mr: hasText ? gaps[size] : 0 }, { children: _jsx(Icon, { name: leftIconName, fill: iconVariants[variant], size: 11 }) })));
        }
        return undefined;
    }, [
        avatar,
        gaps,
        hasIndicator,
        hasText,
        indicatorVariants,
        iconVariants,
        leftIconName,
        size,
        variant,
    ]);
    return (_jsx(BaseBadge, Object.assign({ leftIcon: renderLeftIcon(), rightIcon: rightIconName && (_jsx(Box, Object.assign({ ml: gaps[size] }, { children: _jsx(Icon, { name: rightIconName, fill: iconVariants[variant], size: 12 }) }))), variant: variant, size: size, minWidth: minWidths[size], alignItems: "center", justifyContent: "center" }, (avatar && size !== "xs" ? avatarPaddings[size] : undefined), rest, { children: _jsx(Text, Object.assign({ color: iconVariants[variant], fontSize: "xs" }, { children: children })) })));
};
export default Badge;
